import React from 'react'
import styles from './RowAction.module.scss'
import ActionMenu from 'components/UI/ActionMenu/ActionMenu'
import { permissions } from 'settings/permissions'

const RowAction = ({ action, index, activity }) => {
  const menu = [
    {
      name: 'Edit',
      action: 'edit',
      permission: permissions.change_coinactivity,
    },
    {
      name: 'Delete',
      action: 'delete',
      permission: permissions.delete_coinactivity,
    },
  ]

  return (
    <>
      <div
        className={`${styles.clientContainer} ${index % 2 === 0 ? styles.colorBg : ''}`}
      >
        <div className={styles.containerInf}>
          <div className={`${styles.infStyl} ${styles.name}`}>
            {activity.name}
          </div>
          <div className={styles.buttons}>
            <ActionMenu menu={menu} action={action} items={activity} />
          </div>
        </div>
      </div>
    </>
  )
}

export default RowAction
